import * as React from "react";
import { observer } from "mobx-react-lite";
import styles from "./Pl2GanttView.module.less";
import { getTaskBars, Planning2GanttStore } from "../Planning2GanttStore";
import { Bar } from "./GanttViewTypes";

type PropsPl2GanttView = {
  gantt: Planning2GanttStore;
};

export const Pl2GanttView: React.FC<PropsPl2GanttView> = observer(
  ({ gantt }) => {
    const { totalWidth, totalDays, totalHeight, dayWidth, leftRows, days } =
      gantt;

    const bars = days
      .map(({ key, bk }, i) => {
        if (!bk) return null;
        return { bk, x: i * dayWidth, key };
      })
      .filter((it) => !!it);

    const tasks: Bar[] = [];
    gantt.tasks.forEach((task) => {
      getTaskBars(task).forEach((bar) => tasks.push(bar));
    });

    const grid: [number, number, number, number][] = [];

    // вертикальные линии сетки для разделения дней
    if (dayWidth > 3) {
      for (let i = 0; i <= totalDays; i++) {
        const x = i * dayWidth;
        grid.push([x, 0, x, totalHeight]);
      }
    }

    // горизонтальные линии сетки для разделения строк таблицы
    leftRows.forEach((_, i) => {
      const y = (i + 1) * Planning2GanttStore.cellHeight;
      grid.push([0, y, totalWidth, y]);
    });
    const gridPath = grid
      .map(([ax, ay, bx, by]) => `M${ax} ${ay} L${bx} ${by}`)
      .join(" ");

    return (
      <svg
        width={`${totalWidth}px`}
        height={`${totalHeight}px`}
        viewBox={`0 0 ${totalWidth} ${totalHeight}`}
      >
        {bars.map(({ x, bk, key }) => (
          <rect
            key={key}
            x={x}
            y={0}
            width={dayWidth}
            height={totalHeight}
            className={styles[bk]}
          />
        ))}
        <path d={gridPath} className={styles.grid} />
        {gantt.finalArrowVisible &&
          gantt.arrows.map(({ key, points }) => (
            <React.Fragment key={key}>
              <path
                className={styles.arrowLine}
                d={makeArrowLinePath(points)}
              />
              <path className={styles.arrowEnd} d={makeArrowEndPath(points)} />
            </React.Fragment>
          ))}
        {tasks.map(({ key, x, y, width, height, cls }) => (
          <rect
            key={key}
            x={x}
            y={y}
            width={width}
            height={height}
            className={styles[cls]}
          />
        ))}
      </svg>
    );
  },
);

const makeArrowPath = (points: [number, number][]): string => {
  let path = "";
  points.forEach(([x, y], i) => {
    path += i === 0 ? "M" : "L";
    path += `${x} ${y} `;
  });
  return path;
};
const makeArrowLinePath = (points: [number, number][]): string =>
  makeArrowPath(
    points.map((p, i) => (i === points.length - 1 ? [p[0] - 3, p[1]] : p)),
  );

const makeArrowEndPath = (points: [number, number][]): string => {
  const end = points[points.length - 1];
  if (!end) return "";
  const w = 5;
  const dy = 3;
  const [xr, ym] = end;
  const xl = xr - w;
  return `${makeArrowPath([
    [xr, ym],
    [xl, ym + dy],
    [xl, ym - dy],
  ])} z`;
};
